<template>
    <Modal
        :show-modal="isShowModal"
        :additionalModalStyle="['modal-bcg', 'modal-size']"
        :key-up-event="closeModal"
    >
        <div class="header" slot="header">
            <img class="header-bcg" src="../../assets/modals/logos.png" />
        </div>
        <div class="body" slot="body">
            <h3 class="modal-title">Have You Heard?</h3>
            <p class="modal-paragraph">
                Karma Koin is now Nexon Game Card!
            </p>
            <p class="modal-paragraph">
                Buy Karma Koin, until sold out.
                <br />
                Redeem Karma Koin, wherever Nexon Game Cards <br />are accepted.
            </p>
            <p class="modal-paragraph">
                For more information, see our
                <router-link :to="{ name: 'support' }" class="bottom-action">
                    Support page
                </router-link>
                .
            </p>
        </div>
        <div class="footer" slot="footer">
            <v-btn
                class="close-btn"
                height="30"
                width="100"
                color="primary"
                rounded
                @click="closeModal"
                >Close</v-btn
            >
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal';

export default {
    name: 'RebrandingSiteModal',
    components: { Modal },
    data() {
        return {
            isShowModal: false,
        };
    },
    methods: {
        closeModal() {
            this.isShowModal = false;
            this.setCookieShownModal();
        },
        setCookieShownModal() {
            this.$cookie.set('isShownUpdateToNGCModal', 'Shown', {
                expires: '1Y',
            });
        },
    },
    created() {
        const isShownUpdateToNGCModal = this.$cookie.get(
            'isShownUpdateToNGCModal'
        );
        if (!isShownUpdateToNGCModal) {
            this.isShowModal = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-title {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 25px;

    @include break('sm') {
        font-size: 27px;
        margin-bottom: 35px;
    }
}

.modal-paragraph {
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    margin-bottom: 15px;

    @include break('sm') {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 25px;
    }
}

.bottom-action {
    color: #2960e8;
    text-decoration: underline;
}

.header {
    padding-bottom: 40px;
    display: flex;
    justify-content: center;
    align-content: center;
    .header-bcg {
        width: 210px;
    }
}

.footer {
    display: flex;
    justify-content: center;
    align-content: center;
}

.body {
    margin-bottom: 40px;
    width: 320px;
    @include break('sm') {
        width: 360px;
    }
}
</style>

<style lang="scss">
.modal-bcg {
    background: url('../../assets/modals/background.png') no-repeat -1px 0;
    background-size: cover;
}

.modal-size {
    padding: 20px 20px 20px;

    @include break('sm') {
        padding: 40px 70px 50px;
        min-width: 400px;
    }
}
</style>
